export const iconNames = [
  "home",
  "group",
  "forum",
  "info",
  "notifications",
  "event",
  "school",
  "work",
  "help",
  "star",
  "settings",
  "public",
  "build",
  "code",
  "language",
  "email",
  "account_circle",
  "favorite",
  "dashboard",
  "assignment",
  "attach_file",
  "check_circle",
  "cloud",
  "extension",
  "history",
  "lightbulb",
  "warning",
  "support",
  "restaurant",
  "fitness_center",
  "lock",
  "face",
  "shopping_cart",
  "search",
  "delete",
  "edit",
  "add",
  "remove",
  "thumb_up",
  "thumb_down",
  "visibility",
  "visibility_off",
  "done",
  "clear",
  "menu",
  "close",
  "arrow_forward",
  "arrow_back",
  "arrow_upward",
  "arrow_downward",
  "expand_more",
  "expand_less",
  "check",
  "cancel",
  "apps",
  "bookmark",
  "book",
  "bug_report",
  "camera_alt",
  "photo",
  "place",
  "map",
  "directions",
  "location_on",
  "calendar_today",
  "chat",
  "phone",
  "print",
  "save",
  "sync",
  "update",
  "upload",
  "download",
  "open_in_new",
  "fullscreen",
  "translate",
  "account_box",
  "alarm",
  "battery_full",
  "bluetooth",
  "brightness_high",
  "cast",
  "check_box",
  "chevron_left",
  "chevron_right",
  "filter_list",
  "flag",
  "gps_fixed",
  "language",
  "launch",
  "mark_email_unread",
  "payment",
  "person",
  "person_add",
  "photo_camera",
  "play_arrow",
  "power",
  "refresh",
  "replay",
  "report",
  "security",
  "send",
  "settings_applications",
  "share",
  "sort",
  "storage",
  "text_fields",
  "timeline",
  "trending_up",
  "undo",
  "verified",
  "volume_up",
  "wifi"
];